// extracted by mini-css-extract-plugin
export default {"fullWidth":"vo-z","image":"wo-z","lazyLoadPicture":"xo-z","lazyLoadSpinner":"yo-z","lazyLoadSpin":"zo-z","lazyLoadImage":"Ao-z","hasStyledAspectRatio":"Bo-z"};